<!-- Loader while waiting for data -->
@if (showFormLoader) {
<div class="formLoader">
  <i class="fa fa-spinner fa-spin gt-refresh"></i>
</div>
}

<!-- Content when ready -->
@if (!showFormLoader) {


  <!-- MESSAGE TYPE: Display simple message (e.g., LOCAL_BOOK_AMT) -->
  @if (componentType === 'message') {

    <div class="modal-header">
      <h3 class="modal-title">{{modalTitle}}</h3>
      <div class="header-actions">
        <i class="fa"
           [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
           style="margin-right: 10px; cursor: pointer;"
           (click)="minimise=!minimise"></i>
        <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
      </div>
    </div>

    <div class="modal-body" [hidden]="minimise">
      @if (body) {
<div class="message-container">
        <p>{{body}}</p>
      </div>
}
    </div>

    <div class="modal-footer" [hidden]="minimise">
      <button class="cancel-button"
              type="button"
              (click)="cancel()">Close</button>
    </div>
  
}

  <!-- RECLASS TYPE: 11/30 CY Book Adjustment (LOCAL_BOOK_ADJ_CY) -->
  @if (componentType === 'reclass') {

    <gtw-reclass-local-chart
      [base-urls]="baseURLsString"
      [filter-params]="filterParamsString"
      [header-data]="headerDataString"
      [row-data]="rowDataString"
      (request-grid-update)="onChildRequestGridUpdate($event)">
    </gtw-reclass-local-chart>
  
}

  <!-- TAX-PERM TYPE: CY Local Tax Adjustment Perm (LOCAL_TAX_ADJ_PERM) -->
  @if (componentType === 'tax-perm') {

    <gtw-ep-adjs-local-chart
      [base-urls]="baseURLsString"
      [filter-params]="filterParamsString"
      [header-data]="headerDataString"
      [row-data]="rowDataString"
      [trans-type]="'LOCAL_TAX_ADJ_PERM'"
      (request-grid-update)="onChildRequestGridUpdate($event)">
    </gtw-ep-adjs-local-chart>
  
}

  <!-- EP TYPE: CY Local E&P Adjustment (LOCAL_EP_ADJ) -->
  @if (componentType === 'ep') {

    <gtw-ep-adjs-local-chart
      [base-urls]="baseURLsString"
      [filter-params]="filterParamsString"
      [header-data]="headerDataString"
      [row-data]="rowDataString"
      [trans-type]="'LOCAL_EP_ADJ'"
      (request-grid-update)="onChildRequestGridUpdate($event)">
    </gtw-ep-adjs-local-chart>
  
}

  <!-- ELIM TYPE: Local Eliminations (LOCAL_ELIM) -->
  @if (componentType === 'elim') {

    <gtw-elim-reclass-local
      [base-urls]="baseURLsString"
      [filter-params]="filterParamsString"
      [header-data]="headerDataString"
      [row-data]="rowDataString"
      (request-grid-update)="onChildRequestGridUpdate($event)">
    </gtw-elim-reclass-local>
  
}


}
